import { z } from "zod";

import { OrderDirection } from "@/constants/orderDirection";

import { TAB_ITEMS } from "./-constants";

export const SearchSchema = z.object({
  status: z.nativeEnum(TAB_ITEMS).default(TAB_ITEMS.SAAS),
  pageSize: z.number().default(100),
  pageIndex: z.number().default(0),
  sortColumn: z.string().optional(),
  sortOrder: z.nativeEnum(OrderDirection).optional(),
});

export type SearchSchema = z.infer<typeof SearchSchema>;
